import React, { useState } from 'react';
import { Save } from 'lucide-react';
import Header from '../components/common/Header';
import UserSidebar from '../components/common/UserSidebar';
import { customerService } from '../services/customerService'; 
import { toast } from 'react-toastify';

const UserPasswordPage = () => {
    const userStr = localStorage.getItem('user_info');
    const user = userStr ? JSON.parse(userStr) : {};
    
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({ oldPassword: '', newPassword: '', confirmPassword: '' });

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formData.newPassword !== formData.confirmPassword) {
            toast("Mật khẩu xác nhận không khớp!");
            return;
        }
        setLoading(true);
        try {
            await customerService.changePassword({ 
                oldPassword: formData.oldPassword, 
                newPassword: formData.newPassword 
            });
            
            toast("Đổi mật khẩu thành công! Vui lòng đăng nhập lại.");
            
            localStorage.removeItem('access_token');
            localStorage.removeItem('user_info');
            
            window.location.href = '/login';
            
        } catch (error) {
            const errorMessage = error.response?.data?.message 
                              || error.response?.data 
                              || "Đổi mật khẩu thất bại! Vui lòng kiểm tra lại.";
            
            if (typeof errorMessage === 'object') {
                toast("Mật khẩu mới chưa đủ mạnh (Cần ít nhất 6 ký tự) hoặc sai mật khẩu cũ!");
            } else {
                toast(errorMessage);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col">
            <Header />
            <main className="container mx-auto px-4 py-8 flex-grow">
                <div className="flex flex-col md:flex-row gap-6">
                    <UserSidebar user={user} />
                    {/* 👉 ĐÃ ĐỒNG BỘ NỀN & VIỀN */}
                    <div className="flex-1 bg-gradient-to-b from-orange-50 to-white rounded-xl shadow-sm border border-orange-200/60 p-6 md:p-8">
                        <h2 className="text-xl font-bold text-gray-800 mb-1">Đổi Mật Khẩu</h2>
                        <p className="text-sm text-gray-500 mb-6 pb-4 border-b border-orange-200/60">Để bảo mật tài khoản, vui lòng không chia sẻ mật khẩu cho người khác</p>

                        <form onSubmit={handleSubmit} className="max-w-xl">
                            <div className="space-y-5">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Mật khẩu hiện tại</label>
                                    <input type="password" required value={formData.oldPassword} onChange={e=>setFormData({...formData, oldPassword: e.target.value})} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg outline-none focus:border-tnc-orange focus:ring-1 focus:ring-tnc-orange bg-white"/>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Mật khẩu mới</label>
                                    <input type="password" required value={formData.newPassword} onChange={e=>setFormData({...formData, newPassword: e.target.value})} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg outline-none focus:border-tnc-orange focus:ring-1 focus:ring-tnc-orange bg-white"/>
                                    <p className="text-[11px] text-gray-500 mt-1">Mật khẩu phải có ít nhất 6 ký tự.</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Xác nhận mật khẩu mới</label>
                                    <input type="password" required value={formData.confirmPassword} onChange={e=>setFormData({...formData, confirmPassword: e.target.value})} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg outline-none focus:border-tnc-orange focus:ring-1 focus:ring-tnc-orange bg-white"/>
                                </div>
                                <div className="pt-4 border-t border-orange-100">
                                    <button type="submit" disabled={loading} className="bg-tnc-orange hover:bg-tnc-orange-hover text-white font-bold py-3 px-8 rounded-lg transition-colors flex items-center justify-center gap-2 shadow-sm disabled:bg-gray-400">
                                        {loading ? <span className="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full"></span> : <Save size={18} />}
                                        Xác nhận Đổi
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default UserPasswordPage;